<template>
  <div @click="clickVideo" class="vue-video">
    <vue-core-video-player
      v-bind="$attrs"
      ref="video"
      :src="src"
      :autoplay="autoplay"
      controls="auto"
      autopictureinpicture
      @timeupdate="handleTime"
      @loadeddata="handleLoaded"
    >
  </vue-core-video-player>
  <div v-if="cover && !isPlaying" class="play-overlay">
    <i class="iconfont icon-play"></i>
  </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    src: '',
    cover: null,
    autoplay: {
      type: Boolean,
      default: false
    },
    onTime: {
      type: Function,
      default: () => {}
    },
    onLoaded: {
      type: Function,
      default: () => {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.video.$el.addEventListener(
        'enterpictureinpicture',
        this.enterpictureinpicture
      )
      this.$refs.video.$el.addEventListener(
        'leavepictureinpicture',
        this.leavepictureinpicture
      )
      if (this.cover) {
        this.$refs.video.$el.children[0].poster = this.cover
      }
      this.$refs.video.$children[1].$children[1].$children[2].volume = 100
    })
  },
  beforeDestroy() {
    if (this.$refs.video) {
      this.$refs.video.$el.removeEventListener(
        'enterpictureinpicture',
        this.enterpictureinpicture
      )
      this.$refs.video.$el.removeEventListener(
        'leavepictureinpicture',
        this.leavepictureinpicture
      )
      if (document.pictureInPictureElement) {
        document.exitPictureInPicture().catch((error) => {
          console.log(error)
        })
      }
    }
  },
  data() {
    return {
      isPlaying: false
    }
  },
  methods: {
    clickVideo(e) {
      if (e.target.className === 'vue-core-video-player-layers') {
        if (this.$refs.video.isPlaying) {
          this.$refs.video.pause()
          this.isPlaying = false
        } else {
          this.$refs.video.play()
          this.isPlaying = true
        }
      }
    },
    leavepictureinpicture(e) {
      this.$emit('showDialog', true)
    },
    enterpictureinpicture() {
      this.$emit('showDialog', false)
    },

    handleTime(data) {
      this.onTime(data)
    },
    handleLoaded(data) {
      this.onLoaded(data)
    }
  }
}
</script>

<style lang="scss" scoped>
.vue-video {
  position: relative;
  ::v-deep .vcp-container {
    background-color: #fff;
  }

  .play-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.3);
    pointer-events: none;
    z-index: 1;

    .icon-play {
      font-size: 60px;
      color: #fff;
    }
  }
}
</style>
